// @flow
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import AvaMagnifyingLogoIcon from '../Icons/AvaMagnifying';

import SearchAvaRoomInput from './SearchAvaRoomInput';
import SidebarButton from '../../components/Buttons/SidebarButton';

import { toggleSideBar } from '../../actions';

const useStyles = makeStyles(theme => ({
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: props => (props.sidebarOpen ? 28 : 'none'),
  },
  focused: {
    border: `1px solid ${theme.palette.ava.blue2}`,
    boxShadow: '0px 0px 0px 4px rgba(3, 132, 198, 0.12)',
  },
}));

interface Props {
  sidebarOpen: boolean;
  toggleSideBar: Function;
}

const JoinConversationButton = ({ sidebarOpen, toggleSideBar }: Props) => {
  const classes = useStyles({ sidebarOpen });

  const [buttonClicked, setButtonClicked] = useState(false);

  useEffect(() => {
    if (!sidebarOpen) {
      setButtonClicked(false);
    }
  }, [sidebarOpen]);

  const onClick = () => {
    toggleSideBar(true);
    setButtonClicked(true);
  };

  return (
    <ClickAwayListener onClickAway={() => setButtonClicked(false)}>
      <Box>
        <SidebarButton
          className={classnames({ [classes.focused]: buttonClicked })}
          color="white"
          icon={
            <div className={classes.searchContainer} style={{ marginLeft: sidebarOpen ? 3 : -2 }}>
              <AvaMagnifyingLogoIcon width={28} height={28} />
            </div>
          }
          onClick={onClick}
        >
          <SearchAvaRoomInput autoFocus={buttonClicked} />
        </SidebarButton>
      </Box>
    </ClickAwayListener>
  );
};

const mapStateToProps = ({ scribeSession: { sidebar } }) => ({
  sidebarOpen: sidebar,
});

const mapDispatchToProps = { toggleSideBar };

export default connect(mapStateToProps, mapDispatchToProps)(JoinConversationButton);
